import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
// Import Images
// import dummyImg from "../../../../assets/images/users/user-dummy-img.jpg";

import
{
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  Modal,
  ModalBody,
  Button,
  ModalFooter,
  ModalHeader,
  Form,
  Input,
  Label,
  FormFeedback,
  Tooltip,
} from "reactstrap";

import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../../Components/Common/TableContainer";

import Loader from "../../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../../axiosConfig";
import { useFormik } from "formik";
import * as Yup from "yup";

const Organisateurs = ( props ) =>
{
  const [ loading, setLoading ] = useState( true );
  const [ modalMotif, setModalMotif ] = useState( false );
  const [ organisateurs, setOrganisateurs ] = useState( [] );

  const dispatch = useDispatch();
  // const token = JSON.parse(localStorage.getItem("authUser"))
  //   ? JSON.parse(localStorage.getItem("authUser")).accessToken
  //   : null;

  const fetchOrganizerList = async () =>
  {
    try
    {
      const dataOrganisateur = await axiosInstance.get( `/getAllorganisateur` );
      // console.log( 'dataOrganisateur: ', dataOrganisateur )
      setOrganisateurs( dataOrganisateur.data.data );
      // console.log(course_list);
      // console.log("Course List: ", course_list.data.data);
    } catch ( err )
    {
      console.error( err );
    }
    setLoading( false );
  };

  useEffect( () =>
  {
    try
    {
      fetchOrganizerList();
    } catch ( error )
    {
      console.error( "Erreur de fetch organisateur list: ", error );
    }
    // finally {
    //   setTimeout(() => {
    //     setLoading(false);
    //   }, 2000);
    // }
  }, [] );

  const [ organizerSelected, setOrganizerSelected ] = useState( {} );
  const [ isExportCSV, setIsExportCSV ] = useState( false );
  const [ organisateur, setOrganisateur ] = useState( [] );

  const [ modal, setModal ] = useState( false );
  const [ modalConfirmDelete, setModalConfirmDelete ] = useState( false );

  const toggle = useCallback( () =>
  {
    if ( modal )
    {
      setModal( false );
      setOrganisateur( null );
      setModalMotif( false );
    } else
    {
      setModal( true );
    }
  }, [ modal ] );

  // Add Data
  const handleOrganisateurClicks = () =>
  {
    setOrganisateur( "" );
  };

  const dateFormat = () =>
  {
    var d = new Date(),
      months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
    return d.getDate() + " " + months[ d.getMonth() ] + ", " + d.getFullYear();
  };

  const timeFormat = () =>
  {
    let d = new Date();
    let minutes =
      d.getMinutes().toString().length === 1
        ? "0" + d.getMinutes()
        : d.getMinutes();
    let hours = d.getHours().toString() % 12 || 12;
    hours = hours <= 9 ? ( hours = "0" + hours ) : hours;
    let ampm = d.getHours() >= 12 ? "PM" : "AM";
    return hours + ":" + minutes + ampm;
  };

  // Update Data
  const handleOrganisateurClick = useCallback(
    ( arg ) =>
    {
      const organisateur = arg;

      setOrganisateur( {
        id: organisateur.id,
        user_id: organisateur.user_id,
        first_name: organisateur.first_name,
        last_name: organisateur.last_name,
        email: organisateur.email,
        telephone: organisateur.telephone,
        password: organisateur.password,
        independant: organisateur.independant,
        type_conducteur: organisateur.type_conducteur,
        statut: organisateur.statut,
        etat: organisateur.etat,
        code_parrain: organisateur.code_parrain,
        // piece_identite: organisateur.piece_identite,
        // attestation_residence: organisateur.attestation_residence,
        // permis: organisateur.permis,
        // photo: organisateur.photo,
        marque: organisateur.marque,
        modele: organisateur.modele,
        immatriculation: organisateur.immatriculation,
        type_engin: organisateur.type_engin,
        climatisation: organisateur.climatisation,
        chassie: organisateur.chassie,
        nbr_place: organisateur.nbr_place,
        // assurance: organisateur.assurance,
        // visite_technique: organisateur.visite_technique,
        // photo_engin: organisateur.photo_engin
      } );

      toggle();
    },
    [ toggle ]
  );

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
      //   Cell: ( cellProps ) =>
      //   {
      //     return <input type="checkbox" name="id" className="organisateurCheckBox" value={ cellProps.row.original.id } />;
      //   },
      //   id: '#',
      // },
      {
        Header: props.t( "Last Name" ),
        accessor: "last_name",
        filterable: false,
      },
      {
        Header: props.t( "First Name" ),
        accessor: "first_name",
        filterable: false,
      },
      {
        Header: props.t( "Email" ),
        accessor: "email",
        filterable: false,
      },
      {
        Header: props.t( "Téléphone" ),
        accessor: "telephone",
        filterable: false,
      },
      {
        Header: props.t( "Pays" ),
        accessor: "pays",
        filterable: true,
      },
      {
        Header: props.t( "Etat" ),
        accessor: "etat",
        filterable: true,
        Cell: ( organizer ) => (
          <span
            className={
              organizer.row.original.etat
                ? "badge badge-soft-success me-1"
                : "badge badge-soft-danger me-1"
            }
          >
            { organizer.row.original.etat ? "Activer" : "Désactiver" }
          </span>
        ),
      },
      {
        Header: props.t( "Action" ),
        Cell: ( cellProps ) =>
        {
          const organisateurData = cellProps.row.original;
          const organisateurDataId = cellProps.row.original.id;
          const [ info, setInfo ] = useState( [] );
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title={ props.t( "Voir" ) }>
                <Link
                  to={ `/organisateurs/${ organisateurData.id }` }
                  className="text-success d-inline-block"
                  onClick={ () =>
                  {
                    const organisateurData = cellProps.row.original;
                  } }
                >
                  <i className="ri-eye-fill align-bottom"></i>
                </Link>
              </li>

              {/* <li className="list-inline-item" title={props.t("Supprimer")}>
                <Link
                  to="#"
                  className="btn btn-sm btn-danger d-inline-block"
                  onClick={(e) => {
                    e.preventDefault();
                    const organisateurDataId = cellProps.row.original.id;
                    setOrganizerSelected(organisateurDataId);
                    setModalConfirmDelete(true);
                  }}
                >
                  <i className="ri-close-line align-bottom"></i>
                  Supprimer
                </Link>
              </li> */}

              { organisateurData.etat ? (
                <li
                  className="list-inline-item"
                  title={ organisateurData.motif }
                  role="button"
                >
                  <Link
                    to="#"
                    className="btn btn-sm btn-danger d-inline-block"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      setOrganizerSelected( organisateurData );
                      setModalMotif( true );
                    } }
                  >
                    <i className="ri-close-line align-bottom"></i>
                    Désactiver
                  </Link>
                </li>
              ) : (
                <li className="list-inline-item" title={ props.t( "Activer" ) }>
                  <Link
                    to="#"
                    className="btn btn-sm btn-success d-inline-block"
                    onClick={ ( e ) =>
                    {
                      e.preventDefault();
                      handleaccept( organisateurData );
                    } }
                  >
                    <i className="ri-check-line align-bottom"></i>
                    Activer
                  </Link>
                </li>
              ) }
            </ul>
          );
        },
      },
    ],
    [ handleOrganisateurClick, props ]
    // [setInfo, handleOrganisateurClick, toggle, props, handlerefuse, handleaccept]
  );

  const SUPPORTED_FORMATS = [ "image/*" ];

  const handlerefuse = ( motif ) =>
  {
    console.log( "Compte désactivé: ", organizerSelected );

    axiosInstance
      // 2 : rejeté. `false` valait 0, c'est-à-dire « en attente » : le compte
      // refusé restait indistinguable d'un compte jamais examiné.
      .put( "/etatorga/", {
        id: organizerSelected.id,
        etat: 2,
        motif: motif,
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Organisateur rejeté" );
        fetchOrganizerList();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Le rejet de l’organisateur a échoué" );
      } );
    setOrganizerSelected( {} );
  };

  const handleaccept = ( organizerSelected ) =>
  {
    console.log( "Compte activé: ", organizerSelected );

    axiosInstance
      .put( "/etatorga/", {
        id: organizerSelected.id,
        etat: 1,
      } )
      .then( ( res ) =>
      {
        // console.log(res);
        toast.success( "Organisateur activé avec succès" );
        fetchOrganizerList();
      } )
      .catch( ( err ) =>
      {
        console.error( err );
        toast.error( "Erreur lors de l'activation du organisateur" );
      } );
    setOrganizerSelected( {} );
  };

  const validationRefuse = useFormik( {
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      motif_refuse: "Pas de motif !",
    },
    validationSchema: Yup.object( {
      motif_refuse: Yup.string().required( props.t( "Veuillez entrer un motif" ) ),
    } ),
    onSubmit: ( values ) =>
    {
      // console.log("Motif de la désactivation: ", values.motif_refuse);
      // console.log("Compte désactivé: ", organizerSelected);

      handlerefuse( values.motif_refuse );

      setModalMotif( false );
      setOrganizerSelected( {} );
      fetchOrganizerList();
    },
  } );

  // Organisateur Detail

  document.title = props.t( "Organisateurs | Takci" );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={ props.t( "Organisateurs" ) } pageTitle="Takci" />
          <Row>
            <Col lg={ 12 }>
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-end">
                    <div className="flex-shrink-0">
                      {
                        organisateurs.length > 0 && (
                          <button
                            disabled={
                              organisateurs.length < 0
                            }
                            type="button"
                            className="btn"
                            style={ { color: "#eac22f" } }
                            onClick={ () => setIsExportCSV( true ) }
                          >
                            <i className="ri-file-download-line align-bottom me-1"></i>{ " " }
                            { props.t( "Export" ) }
                          </button>
                        ) }
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={ 12 }>
              <Card id="organisateurList">
                <CardBody className="pt-0">
                  <div>
                    { !loading ? (
                      organisateurs.length > 0 ? (
                        <>
                          <ExportCSVModal
                            show={ isExportCSV }
                            onCloseClick={ () => setIsExportCSV( false ) }
                            data={
                              !loading && organisateurs.length > 0
                                ? organisateurs
                                : []
                            }
                          />

                          <TableContainer
                            columns={ columns }
                            data={ organisateurs || [] }
                            isGlobalFilter={ true }
                            isAddUserList={ false }
                            customPageSize={ 8 }
                            className="custom-header-css"
                            divClass="table-responsive table-card mb-3"
                            tableClass="align-middle table-nowrap"
                            theadClass="table-light"
                            handleOrganisateurClick={ handleOrganisateurClicks }
                          />
                        </>
                      ) : (
                        <Col
                          lg="12"
                          className="p-4 border-top border-top-dashed"
                        >
                          <h6 className="text-muted text-uppercase fw-semibold mb-4">
                            Aucun organisateur disponible
                          </h6>
                        </Col>
                      )
                    ) : (
                      <div className="text-center my-3">
                        {/* <Spinner size="sm" className=''
                            style={ { color: '#014c94' } }
                          /> */}
                        <Loader style={ { color: "#014c94" } } />
                        <h2>Chargement...</h2>
                      </div>
                    ) }
                  </div>

                  <Modal
                    id="showModalMotif"
                    style={ { maxWidth: 800 } }
                    isOpen={ modalMotif }
                    centered
                  >
                    <ModalHeader className="bg-soft-info p-3">
                      { props.t( "Motif de la désativation" ) }
                    </ModalHeader>

                    <Form
                      onSubmit={ ( e ) =>
                      {
                        e.preventDefault();
                        validationRefuse.handleSubmit();
                        return false;
                      } }
                    >
                      <ModalBody>
                        <Input type="hidden" id="id-field" />
                        <Row className="g-3">
                          <Col lg={ 12 }>
                            <div>
                              <Label
                                htmlFor="motif_refuse"
                                className="form-label"
                              >
                                { props.t( "Motif" ) }{ " " }
                                <span style={ { color: "red" } }>*</span>
                              </Label>
                              <Input
                                name="motif_refuse"
                                id="motif_refuse"
                                className="form-control"
                                placeholder={ props.t( "Entrez le motif" ) }
                                type="textarea"
                                validate={ {
                                  required: { value: true },
                                } }
                                onChange={ validationRefuse.handleChange }
                                onBlur={ validationRefuse.handleBlur }
                                value={
                                  validationRefuse.values.motif_refuse || ""
                                }
                                invalid={
                                  validationRefuse.touched.motif_refuse &&
                                    validationRefuse.errors.motif_refuse
                                    ? true
                                    : false
                                }
                              />
                              { validationRefuse.touched.motif_refuse &&
                                validationRefuse.errors.motif_refuse ? (
                                <FormFeedback type="invalid">
                                  { validationRefuse.errors.motif_refuse }
                                </FormFeedback>
                              ) : null }
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <div className="hstack gap-2 justify-content-end">
                          <Button
                            type="button"
                            onClick={ () =>
                            {
                              setModalMotif( false );
                              setOrganizerSelected( {} );
                            } }
                            className="btn-light"
                          >
                            { props.t( "Fermer" ) }
                          </Button>
                          {/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetChauffeurs); }} > {props.t("Fermer")} </button> */ }
                          <Button
                            type="submit"
                            className="btn btn-primary"
                            id="add-motif-btn"
                            style={ { background: "#002437", color: "white" } }
                          >
                            Envoyer la Motif
                          </Button>
                        </div>
                      </ModalFooter>
                    </Form>
                  </Modal>

                  <ToastContainer closeButton={ false } />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Organisateurs.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter( withTranslation()( Organisateurs ) );
